var amdi18n={"__root":{"choose_identity":"Choose identity","no_identity_available":"No identity available","not_available":"not available","not_supported":"not supported","cloud_identity":"Cloud Identity","cannot_create_cloud_identity":"Cloud Identity can't be created","create_cloud_identity":"Create Cloud Identity","cloud_identity_expired":"Cloud Identity expired","cloud_identity_deactivated":"Cloud Identity deactivated","identity_management":"Identity Management"},"__de":{"choose_identity":"Identität auswählen","no_identity_available":"Keine Identität verfügbar","not_available":"nicht verfügbar","not_supported":"nicht unterstützt","cloud_identity":"Cloud Identität","cannot_create_cloud_identity":"Cloud Identität kann nicht erzeugt werden","create_cloud_identity":"Erstelle Cloud Identität","cloud_identity_expired":"Cloud Identität abgelaufen","cloud_identity_deactivated":"Cloud Identität deaktiviert","identity_management":"Identitätsmanagement"}};amdi18n.init=function(language){
		// get the default language
		if(!language){
			if(window._i18n && window._i18n.locale){
				language = window._i18n.locale;
			}else if(document.documentElement.lang){
				language = document.documentElement.lang;
			}else{
				language = 'root';
			}
		}
		var target = this['__' + language] || this.__root;

		// copy definition to root level
		if (target) {
			for (var name in target) {
				this[name] = target[name];
			}
		}

		// fallback to root
		for(var name in this.__root){
			if(typeof this[name] === 'undefined'){
				this[name] = this.__root[name];
			}
		}
	};amdi18n.init();module.exports=amdi18n;


//////////////////
// WEBPACK FOOTER
// ./node_modules/amdi18n-loader!./src/main/web/js/app/state/nls/AuthenticationOptionSelectionState_strings.js
// module id = 94
// module chunks = 2